var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tech-inno-activities"},[_c('ds-header',{attrs:{"title":"科创活动管理"}}),_c('activity-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }